/* eslint-disable no-dupe-keys */
import React, { useState, useEffect } from "react";
/*import { Upload } from "../../EntryFile/imagePath";*/

import AuthUser from "../../components/AuthUser";

import { toast, ToastContainer } from 'react-toastify';

import Spinner from "../../components/Spinner";

import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';

import Swal from "sweetalert2";

const Novasemente = ({ permissaoAdicionar }) => {

  const history = useHistory();

  // eslint-disable-next-line no-unused-vars
  const { http, url_root, empresa_selecionada } = AuthUser();
  const [nome, setNome] = useState('');
  const [unidade, setUnidade] = useState('');
  const [obs, setObs] = useState(0);
  const [tiposementeSelecionada, settiposementeSelecionada] = useState(null);
  const [sementeSelecionada, setsementeSelecionada] = useState(null);
  const [sementesmaiores, setsementesmaiores] = useState([]);
  const [tipossemente, settipossemente] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [imagem, setSelectedFile] = useState(null);
  const [imagem2, setSelectedFile2] = useState(null);

  const [permanecerNaPagina, setPermanecerNaPagina] = useState(true);

  const handlePermanecerNaPagina = () => {
    setPermanecerNaPagina(!permanecerNaPagina);
  };

  const navegarParaLista = () => {
    history.push('/dream-pos/semente/sementelista');
  };

  const navegarParaEdicao = (id) => {
    history.push('/dream-pos/semente/sementeedit/' + id);
  };

  useEffect(() => {
    getsementesmaiores();
  }, []);

  const getsementesmaiores = async () => {
    try {

      /* Outras sementes */

      setLoading(true); // Set loading to true when the request starts

      const resultado = await http.get('/sementes/onlyparents');

      setsementesmaiores(resultado.data.sementes);

      setLoading(false);

      /* Outras sementes */

      setLoading(true); // Set loading to true when the request starts

      const res = await http.get('/sementes/tipos');

      settipossemente(res.data.tipos_semente);

      settiposementeSelecionada(res.data.tipos_semente[0].id);

      setLoading(false);

      /* Outras sementes */


    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.log('Utilizador não autenticado.');
      } else {
        console.log('Ocorreu um erro inesperado. Por favor, tente mais tarde.');
      }
    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };



  const handleFileChange = (e) => {
    // Lógica para processar a imagem, se necessário
    setSelectedFile(e.target.files[0]);

    // Restante do código
  };

  const handleFileChange2 = (e) => {
    // Lógica para processar a imagem, se necessário
    setSelectedFile2(e.target.files[0]);

    // Restante do código
  };

  const toggleLoading = (value) => {
    setLoading(value);
  };

  const submitForm = async () => {

    if (permissaoAdicionar) {
      try {
        toggleLoading(true);

        // Basic form validation
        if (nome.length < 2) {
          setError('O nome deve ter pelo menos dois caracteres.');
          setLoading(false);

          // Show a error toast
          toast.error('O nome deve ter pelo menos dois caracteres.', {
            position: 'top-right',
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

          return;
        }

        // Basic form validation
        if (obs.length < 2) {
          setError('A Observação deve ter pelo menos dois caracteres.');
          setLoading(false);

          // Show a error toast
          toast.error('A observação deve ter pelo menos dois caracteres.', {
            position: 'top-right',
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

          return;
        }

         // Basic form validation
         if (unidade.length < 2) {
          setError('A Unidade deve ter pelo menos dois caracteres.');
          setLoading(false);

          // Show a error toast
          toast.error('A Unidade deve ter pelo menos dois caracteres.', {
            position: 'top-right',
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

          return;
        }

        await uploadsemente();


      } catch (error) {
        if (error.response && error.response.status === 401) {
          setError('Utilizador não autenticado.');

          // Show a error toast
          toast.error('Utilizador não autenticado.', {
            position: 'top-right',
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

        } else {
          setError('Ocorreu um erro inesperado. Por favor, tente novamente mais tarde. Verifique tambem se o e-mail ja esta registado');

          // Show a error toast
          toast.error('Ocorreu um erro inesperado. Por favor, tente novamente mais tarde. Verifique tambem se o e-mail ja esta registado', {
            position: 'top-right',
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

        }
      } finally {
        toggleLoading(false);
      }

    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };


  const uploadsemente = async () => {
    try {
      const formData = new FormData();
      formData.append('nome', nome);
      formData.append('obs', obs);
      formData.append('unidade', unidade);

      formData.append('empresa_id', empresa_selecionada.id);

      if (sementeSelecionada != null && sementeSelecionada != '')
        formData.append('parent_id', sementeSelecionada);

      formData.append('tipo_id', tiposementeSelecionada);
      formData.append('imagem', imagem);
      formData.append('imagem2', imagem2);
      formData.append('estado', 0);

      const response = await http.post('/semente/register', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      // Show a success toast
      toast.success(response.data.message, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        onClose: () => {
          // Redirecionar para a lista de sementes após o cadastro bem-sucedido

          setNome('');
          setSelectedFile(null);

          if (!permanecerNaPagina) {
            navegarParaLista();
          } else {
            navegarParaEdicao(response.data.data.id);
          }
        },
      });

    } catch (error) {
      console.error(error);

      toast.error('Ocorreu um erro ao carregar o semente. Por favor, tente novamente mais tarde.', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const handleSelectTipoSementeChange = (id) => {

    settiposementeSelecionada(id);

  };

  const handleSelectsementeChange = (id) => {

    if (id == null || id == 'Nenhuma' || id == '')
      setsementeSelecionada(null);
    else
      setsementeSelecionada(id);

  };

  const renderOptions = (sementes) => {
    return sementes.map((semente) => (
      <React.Fragment key={semente.id}>
        <option value={semente.id}>{semente.nome}</option>
        {semente.children && semente.children.length > 0 && renderOptions(semente.children)}
      </React.Fragment>
    ));
  };

  const renderOptionstipossemente = (regions) => {
    return regions.map((region) => (
      <React.Fragment key={region.id}>
        <option value={region.id}>{region.designacao}</option>
        {region.children && region.children.length > 0 && renderOptions(region.children)}
      </React.Fragment>
    ));
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="titles">
            <i alt="Image" className="header-image fa fa-braille border p-3 rounded-3"></i>
            <div>
              <h4>Gestão de sementes de plantio</h4>
              <h6>Adicionar semente de plantio</h6>
            </div>
          </div>
        </div>
        {/* /add */}
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-4 col-sm-6 col-12">
                <div className="form-group">
                  <label>Nome de semente</label>
                  <input type="text" value={nome} onChange={e => setNome(e.target.value)} />
                </div>

                <div className="form-group">
                  <label>Hierarquia superior da semente :</label>

                  <select
                    name="parent_id"
                    onChange={(e) => handleSelectsementeChange(e.target.value)}
                    value={sementeSelecionada == null ? '' : sementeSelecionada}
                    className="form-control select"

                  ><option key={0} value={null}>Nenhuma</option>
                    {renderOptions(sementesmaiores)}
                  </select>

                </div>

              </div>
              <div className="col-lg-4 col-sm-6 col-12">


                <div className="form-group">
                  <label>Tipo de semente</label>

                  <select
                    name="tipo_id"
                    onChange={(e) => handleSelectTipoSementeChange(e.target.value)}
                    value={tiposementeSelecionada}
                    className="form-control select"
                  >
                    {renderOptionstipossemente(tipossemente)}
                  </select>

                </div>


                <div className="form-group">
                  <label>Unidade</label>
                  <input type="text" value={unidade} onChange={e => setUnidade(e.target.value)} />
                </div>

              </div>    

              <div className="col-lg-4 col-sm-6 col-12">
                
                <div className="form-group">
                  {/* Checkbox "Permanecer na Página" */}
                  <label>
                    <input
                      type="checkbox"
                      checked={permanecerNaPagina}
                      onChange={handlePermanecerNaPagina}
                    />
                    &nbsp; Permanecer na Página depois de salvar
                  </label>
                </div>

              </div>          

              <div className="col-lg-8 col-sm-6 col-12">
                <div className="form-group">
                  <label>obs</label>
                  <input type="text" value={obs} onChange={e => setObs(e.target.value)} />
                </div>
              </div>

              <div className="col-lg-12 col-sm-12 col-12 row">
                <div className="form-group col-6">
                  <label>imagem da semente</label>
                  <div className="image-upload image-upload-new">
                    <input type="file" name="imagem" onChange={handleFileChange} />
                    <div className="image-uploads">
                      {imagem ? (
                        <>
                          <img id="imagem"
                            src={URL.createObjectURL(imagem)}
                            alt="Pré-visualização"
                          />
                          <h4>Carregar imagem</h4>
                        </>
                      ) : (

                        <>
                          <img id="imagem"
                            alt="Pré-visualização"
                          />
                          <h4>Carregar imagem</h4>
                        </>

                      )}

                    </div>
                  </div>
                </div>

                <div className="form-group col-6">
                  <label>Imagem do produto comércial</label>
                  <div className="image-upload image-upload-new">
                    <input type="file" name="imagem2" onChange={handleFileChange2} />
                    <div className="image-uploads">
                      {imagem2 ? (
                        <>
                          <img id="imagem2"
                            src={URL.createObjectURL(imagem2)}
                            alt="Pré-visualização"
                          />
                          <h4>Carregar imagem</h4>
                        </>
                      ) : (

                        <>
                          <img id="imagem2"
                            alt="Pré-visualização"
                          />
                          <h4>Carregar imagem</h4>
                        </>

                      )}

                    </div>
                  </div>
                </div>

              </div>

              <div className="col-lg-12">
                <a onClick={submitForm} className="btn btn-submit me-2">
                  {loading ? <Spinner /> : 'Salvar'}
                </a>
                <a onClick={navegarParaLista} className="btn btn-cancel">
                  Cancelar
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* /add */}
      </div>

      <ToastContainer />

    </div>
  );
};

Novasemente.propTypes = {
  permissaoAdicionar: PropTypes.bool.isRequired
};


export default Novasemente;
